/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BCMOsisRuleFormDataRouteRestriction,
    BCMOsisRuleFormDataRouteRestrictionFromJSON,
    BCMOsisRuleFormDataRouteRestrictionFromJSONTyped,
    BCMOsisRuleFormDataRouteRestrictionToJSON,
    BCMOsisRuleFormDataTravelDateRestriction,
    BCMOsisRuleFormDataTravelDateRestrictionFromJSON,
    BCMOsisRuleFormDataTravelDateRestrictionFromJSONTyped,
    BCMOsisRuleFormDataTravelDateRestrictionToJSON,
    BrandAndMarketListItem,
    BrandAndMarketListItemFromJSON,
    BrandAndMarketListItemFromJSONTyped,
    BrandAndMarketListItemToJSON,
    CodeAndLabel,
    CodeAndLabelFromJSON,
    CodeAndLabelFromJSONTyped,
    CodeAndLabelToJSON,
    DateTimeRestrictionData,
    DateTimeRestrictionDataFromJSON,
    DateTimeRestrictionDataFromJSONTyped,
    DateTimeRestrictionDataToJSON,
    GuidIdCodeAndLabel,
    GuidIdCodeAndLabelFromJSON,
    GuidIdCodeAndLabelFromJSONTyped,
    GuidIdCodeAndLabelToJSON,
} from './';

/**
 * 
 * @export
 * @interface BCMOsisRuleFormData
 */
export interface BCMOsisRuleFormData {
    /**
     * 
     * @type {string}
     * @memberof BCMOsisRuleFormData
     */
    id?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof BCMOsisRuleFormData
     */
    disabled?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BCMOsisRuleFormData
     */
    allowEdit?: boolean;
    /**
     * 
     * @type {string}
     * @memberof BCMOsisRuleFormData
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BCMOsisRuleFormData
     */
    comment?: string | null;
    /**
     * 
     * @type {Array<GuidIdCodeAndLabel>}
     * @memberof BCMOsisRuleFormData
     */
    marketingCarriers?: Array<GuidIdCodeAndLabel> | null;
    /**
     * 
     * @type {Array<CodeAndLabel>}
     * @memberof BCMOsisRuleFormData
     */
    fareTypes?: Array<CodeAndLabel> | null;
    /**
     * 
     * @type {Array<BCMOsisRuleFormDataTravelDateRestriction>}
     * @memberof BCMOsisRuleFormData
     */
    travelDates?: Array<BCMOsisRuleFormDataTravelDateRestriction> | null;
    /**
     * 
     * @type {Array<BCMOsisRuleFormDataRouteRestriction>}
     * @memberof BCMOsisRuleFormData
     */
    routes?: Array<BCMOsisRuleFormDataRouteRestriction> | null;
    /**
     * 
     * @type {BrandAndMarketListItem}
     * @memberof BCMOsisRuleFormData
     */
    brandAndMarket?: BrandAndMarketListItem;
    /**
     * 
     * @type {Array<string>}
     * @memberof BCMOsisRuleFormData
     */
    osIs?: Array<string> | null;
    /**
     * 
     * @type {Array<DateTimeRestrictionData>}
     * @memberof BCMOsisRuleFormData
     */
    dateTimeRestrictions?: Array<DateTimeRestrictionData> | null;
    /**
     * 
     * @type {CodeAndLabel}
     * @memberof BCMOsisRuleFormData
     */
    dateTimeRestrictionsTimeZone?: CodeAndLabel;
    /**
     * 
     * @type {Array<string>}
     * @memberof BCMOsisRuleFormData
     */
    providers?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof BCMOsisRuleFormData
     */
    accountCodes?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof BCMOsisRuleFormData
     */
    excludeAccountCodes?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof BCMOsisRuleFormData
     */
    fareBasisCodes?: Array<string> | null;
}

export function BCMOsisRuleFormDataFromJSON(json: any): BCMOsisRuleFormData {
    return BCMOsisRuleFormDataFromJSONTyped(json, false);
}

export function BCMOsisRuleFormDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): BCMOsisRuleFormData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'disabled': !exists(json, 'disabled') ? undefined : json['disabled'],
        'allowEdit': !exists(json, 'allowEdit') ? undefined : json['allowEdit'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'comment': !exists(json, 'comment') ? undefined : json['comment'],
        'marketingCarriers': !exists(json, 'marketingCarriers') ? undefined : (json['marketingCarriers'] === null ? null : (json['marketingCarriers'] as Array<any>).map(GuidIdCodeAndLabelFromJSON)),
        'fareTypes': !exists(json, 'fareTypes') ? undefined : (json['fareTypes'] === null ? null : (json['fareTypes'] as Array<any>).map(CodeAndLabelFromJSON)),
        'travelDates': !exists(json, 'travelDates') ? undefined : (json['travelDates'] === null ? null : (json['travelDates'] as Array<any>).map(BCMOsisRuleFormDataTravelDateRestrictionFromJSON)),
        'routes': !exists(json, 'routes') ? undefined : (json['routes'] === null ? null : (json['routes'] as Array<any>).map(BCMOsisRuleFormDataRouteRestrictionFromJSON)),
        'brandAndMarket': !exists(json, 'brandAndMarket') ? undefined : BrandAndMarketListItemFromJSON(json['brandAndMarket']),
        'osIs': !exists(json, 'osIs') ? undefined : json['osIs'],
        'dateTimeRestrictions': !exists(json, 'dateTimeRestrictions') ? undefined : (json['dateTimeRestrictions'] === null ? null : (json['dateTimeRestrictions'] as Array<any>).map(DateTimeRestrictionDataFromJSON)),
        'dateTimeRestrictionsTimeZone': !exists(json, 'dateTimeRestrictionsTimeZone') ? undefined : CodeAndLabelFromJSON(json['dateTimeRestrictionsTimeZone']),
        'providers': !exists(json, 'providers') ? undefined : json['providers'],
        'accountCodes': !exists(json, 'accountCodes') ? undefined : json['accountCodes'],
        'excludeAccountCodes': !exists(json, 'excludeAccountCodes') ? undefined : json['excludeAccountCodes'],
        'fareBasisCodes': !exists(json, 'fareBasisCodes') ? undefined : json['fareBasisCodes'],
    };
}

export function BCMOsisRuleFormDataToJSON(value?: BCMOsisRuleFormData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'disabled': value.disabled,
        'allowEdit': value.allowEdit,
        'description': value.description,
        'comment': value.comment,
        'marketingCarriers': value.marketingCarriers === undefined ? undefined : (value.marketingCarriers === null ? null : (value.marketingCarriers as Array<any>).map(GuidIdCodeAndLabelToJSON)),
        'fareTypes': value.fareTypes === undefined ? undefined : (value.fareTypes === null ? null : (value.fareTypes as Array<any>).map(CodeAndLabelToJSON)),
        'travelDates': value.travelDates === undefined ? undefined : (value.travelDates === null ? null : (value.travelDates as Array<any>).map(BCMOsisRuleFormDataTravelDateRestrictionToJSON)),
        'routes': value.routes === undefined ? undefined : (value.routes === null ? null : (value.routes as Array<any>).map(BCMOsisRuleFormDataRouteRestrictionToJSON)),
        'brandAndMarket': BrandAndMarketListItemToJSON(value.brandAndMarket),
        'osIs': value.osIs,
        'dateTimeRestrictions': value.dateTimeRestrictions === undefined ? undefined : (value.dateTimeRestrictions === null ? null : (value.dateTimeRestrictions as Array<any>).map(DateTimeRestrictionDataToJSON)),
        'dateTimeRestrictionsTimeZone': CodeAndLabelToJSON(value.dateTimeRestrictionsTimeZone),
        'providers': value.providers,
        'accountCodes': value.accountCodes,
        'excludeAccountCodes': value.excludeAccountCodes,
        'fareBasisCodes': value.fareBasisCodes,
    };
}


